/**
 * Valida si la fecha existe en el calendario. Para el día, el número no
 * inicia desde 0, para el mes, sí. Por ejemplo, para el día 31 del mes,
 * pasar `day`: 31. Para el mes de enero, pasar `month`: 0.
 *
 * ejemplos:
 * `(2021, 1, 31) => false` porque 31-02-2021 no existe en el calendario.
 * `(2021, 11, 25) => true` porque 25-12-2021 sí existe en el calendario.
 *
 * @param {number} year ejm: 2021
 * @param {number} month ejm: 0
 * @param {number} day ejm: 25
 * @returns true|false
 */
const dateExistsInCalendar = (year, month, day) => {
  const date = new Date(year, month, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month &&
    date.getDate() === day
  );
};

export default dateExistsInCalendar;
